'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  _createClass(_class, [{
    key: 'init',
    value: function init() {
      var _this = this;

      this.$el = $('[data-role="slick"]');

      this.$el.each(function (index, el) {
        var $el = $(el);

        $el.data('slick') ? $el.slick() : $el.slick(_this.getConfig($el));
      });
    }
  }, {
    key: 'getConfig',
    value: function getConfig($el) {
      var data = $el.data();
      var config = Object.assign({}, App.config.slick.config);
      var responsive = [];

      config.dots = data.hasOwnProperty('dots');
      config.arrows = data.hasOwnProperty('arrows');

      var breakpoint = 0;
      for (var key in App.config.slick.responsive) {
        var cfg = App.config.slick.responsive[key];
        var Key = this.capitalize(key);
        var defined = false;

        if (data.hasOwnProperty('show' + Key)) {
          cfg.settings.slidesToShow = data['show' + Key];

          if (cfg.breakpoint > breakpoint) {
            config.slidesToShow = cfg.settings.slidesToShow;
            config.slidesToScroll = cfg.settings.slidesToScroll;
            breakpoint = cfg.breakpoint;
          }

          defined = true;
        }

        if (data.hasOwnProperty('slide' + Key)) {
          cfg.settings.slidesToScroll = data['slide' + Key];
        }

        if (defined) {
          responsive.push(cfg);
        }
      }

      if (responsive.length) {
        config.responsive = responsive;
      }

      return config;
    }
  }, {
    key: 'capitalize',
    value: function capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  }]);

  return _class;
}();

export default _class;


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/modules/slick/index.js
// module id = zM0Y
// module chunks = 4